__turbopack_context__.v({
  "avatar": "MobileTopBar-module-scss-module__RhfqGq__avatar",
  "chat": "MobileTopBar-module-scss-module__RhfqGq__chat",
  "dot": "MobileTopBar-module-scss-module__RhfqGq__dot",
  "green": "MobileTopBar-module-scss-module__RhfqGq__green",
  "name": "MobileTopBar-module-scss-module__RhfqGq__name",
  "navs": "MobileTopBar-module-scss-module__RhfqGq__navs",
  "newNotifications": "MobileTopBar-module-scss-module__RhfqGq__newNotifications",
  "premiumButtom": "MobileTopBar-module-scss-module__RhfqGq__premiumButtom",
  "red": "MobileTopBar-module-scss-module__RhfqGq__red",
  "root": "MobileTopBar-module-scss-module__RhfqGq__root",
  "unreadMessages": "MobileTopBar-module-scss-module__RhfqGq__unreadMessages",
});
